import styled from 'styled-components';

import {Device} from '../../../constants';

const StyledTextWrapper = styled.div`
  display: block;
  padding: 1em 0;
  @media screen and ${Device.mobileL} {
    display: flex;
    flex-direction: column;
  }
`;

export default StyledTextWrapper;
